export default __webpack_public_path__ + "static/media/promo.87905e66.svg";